/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class AutomateRouter extends React.Component {

	render() {

		return (
			<Outlet context={this.props}/>
		);

	}
}

export default ComponentWithContext(AutomateRouter);
